const NewsletterBox = () => {
    return (
        <section className="newsletterBox">
            <h4>Iscriviti alla newsletter</h4>
            <p>Iscriviti alla newsletter gratuita e ricevi tutte le notizie <span className="bold">Altalex</span></p>
            <div className="btn full blu">
                <a href="https://www.altalex.com/sso-redirect?url=/area-personale">Iscriviti</a>
            </div>
        </section>
    )
}

export default NewsletterBox;